// extracted by mini-css-extract-plugin
export default {"control":"control_control__NjY-o","button":"control_button__S3YTX"};